const newsData =  [
    {
      id: 1,
      title: "Menteri Trenggono: Kebijakan PIT Selaras dengan Upaya FAO Berantas IUUF",
      scope: [
        {
          title: "KEMENTERIAN KELAUTAN DAN PERIKANAN",
          code: "MENTERI"
        }
      ],
      created: "08 Mei 2023",
      image: "https: //portalkkp.coofis.com/media/news_kkp/KKP FAO PSMA.jpeg",
      by: "KEMENTERIAN KELAUTAN DAN PERIKANAN",
      subtitle: "<p>BALI, (8/5) - Menteri Kelautan dan Perikanan Sakti Wahyu Trenggono menegaskan kebijakan penangkapan ikan terukur (PIT) sejalan dengan upaya Organisasi Pangan Dunia (FAO) dalam memberantas praktik illegal unreported unregulated fishing (IUU Fishing).</p>",
      description: "<p>Hal ini disampaikannya dalam 4th Meeting of the Parties The FAO Agreement on Port State Measures (PSMA) yang berlangsung di Bali, Senin (8/5/2023). Pertemuan diikuti 243 partisipan yang terdiri dari negara anggota PSMA, negara anggota FAO dan organisasi internasional serta mitra observer dari berbagai negara.</p><p>\"Penangkapan ikan secara terukur berbasis kuota dapat mendukung tujuan PSMA untuk mencegah penangkapan ikan Ilegal, tidak diatur dan tidak terlaporkan (IUU Fishing) serta mempromosikan praktik penangkapan ikan yang bertanggung jawab,\" ungkap Menteri Trenggono saat membuka pertemuan.</p>"
    },
    {
      id: 2,
      title: "KKP Hentikan Proyek Reklamasi Galangan Kapal di Batam",
      scope: [
        {
          title: "KEMENTERIAN KELAUTAN DAN PERIKANAN",
          code: "MENTERI"
        }
      ],
      created: "08 Mei 2023",
      image: "https: //portalkkp.coofis.com/media/news_kkp/KKP FAO PSMA.jpeg",
      by: "KEMENTERIAN KELAUTAN DAN PERIKANAN",
      subtitle: "<p>BATAM (6/5) – Kementerian Kelautan dan Perikanan (KKP) menghentikan proyek reklamasi galangan kapal milik PT. BSI di Batam, Kepulauan Riau pada Jumat (5/5) usai temukan indikasi pelanggaran pemanfaatan ruang laut.</p>",
      description: "<p>Berdasarkan investigasi berbasis Marine Intelligence (Intelijen Kelautan) yang dilakukan oleh Polisi Khusus Pengelolaan Wilayah Pesisir dan Pulau-Pulau Kecil (Polsus PWP3K), kegiatan reklamasi seluas 1,191 hektar (ha) tersebut tidak dilengkapi dengan dokumen Persetujuan Kesesuaian Kegiatan Pemanfaatan Ruang Laut (PKKPRL).</p>"
    },
    {
      id: 3,
      title: "Dukung Terwujudnya Kebijakan Prioritas, KKP Lantik P3T Ahli Utama",
      scope: [
        {
          title: "DIREKTORAT JENDERAL PERIKANAN TANGKAP",
          code: "DJPT"
        }
      ],
      created: "02 Mei 2023",
      image: "https: //portalkkp.coofis.com/media/news_kkp/KKP_Latih_Nelayan_untuk_Kawal_Blue_Economy_1.jpeg",
      by: "DIREKTORAT JENDERAL PERIKANAN TANGKAP",
      subtitle: "<p>JAKARTA (2/5) Sekretaris Direktorat Jenderal Perikanan Tangkap Trian Yunanda melantik M. Zaini Hanafi sebagai Pejabat Fungsional Pengelola Produksi Perikanan Tangkap (P3T) Ahli Utama untuk mendukung implementasi kebijakan prioritas Kementerian Kelautan dan Perikanan.</p>",
      description: "<p>Menurut Trian, pengisian jabatan fungsional ini didasarkan pada keahlian dan profesionalisme tertentu. Selain itu juga merupakan pengembangan karir bagi seorang aparatur sipil negara.</p>"
    },
    {
      id: 4,
      title: "KKP Genjot Produksi Si Emas Hitam",
      scope: [
        {
          title: "KEMENTERIAN KELAUTAN DAN PERIKANAN",
          code: "MENTERI"
        },
        {
          title: "DIREKTORAT JENDERAL PERIKANAN TANGKAP",
          code: "DJPT"
        },
        {
          title: "DIREKTORAT JENDERAL PERIKANAN BUDIDAYA",
          code: "DJPB"
        }
      ],
      created: "17 April 2023",
      image: "https: //portalkkp.coofis.com/media/news_kkp/KKP_Latih_Nelayan_untuk_Kawal_Blue_Economy_1.jpeg",
      by: "DIREKTORAT JENDERAL PERIKANAN TANGKAP",
      subtitle: "<p>JAKARTA, (17/4) – Kementerian Kelautan dan Perikanan terus menggenjot produksi ikan nila sebagai salah satu komoditas utama perikanan budidaya. Si emas hitam ini memiliki keunggulan seperti tolerasi terhadap kondisi lingkungan, kemampuan tumbuh yang baik, dapat dibudidayakan di air tawar maupun payau, memiliki kandungan protein tinggi, serta harga yang bersaing.</p>",
      description: "<p>Ikan nila saat ini semakin diminati masyarakat, sehingga permintaan pasar meningkat tinggi. Selain untuk konsumsi lokal, permintaan terhadap komoditas ikan nila untuk ekspor terutama dari Amerika Serikat juga tinggi khususnya dalam bentuk fillet.</p>"
    },
    {
      id: 5,
      title: "KKP: Obat Ikan Terdaftar Tingkatkan Daya Saing Ikan",
      scope: [
        {
          title: "KEMENTERIAN KELAUTAN DAN PERIKANAN",
          code: "MENTERI"
        },
        {
          title: "DIREKTORAT JENDERAL PERIKANAN BUDIDAYA",
          code: "DJPB"
        }
      ],
      created: "17 April 2023",
      image: "https: //portalkkp.coofis.com/media/news_kkp/news5.jpeg",
      by: "DIREKTORAT JENDERAL PERIKANAN TANGKAP",
      subtitle: "<p>JAKARTA (15/4) – Kementerian Kelautan dan Perikanan terus mensosialisasikan kepada para pelaku usaha produsen obat ikan agar memiliki sertifikat Cara Pembuatan Obat Ikan yang Baik (CPOIB) dan produknya harus terdaftar. KKP menegaskah bahwa obat ikan yang terdaftar telah melalui serangkaian pengujian dan evaluasi sehingga memenuhi persyaratan keamanan, mutu dan khasiat serta daya saing produk perikanan yang dihasilkan.</p>",
      description: "<p>'Semuanya dalam rangka menjamin mutu obat ikan yang aman bagi ikan, lingkungan dan manusia yang pada akhirnya produk hasil perikanan budidaya memenuhi persyaratan keamanan pangan' tegas Direktur Jenderal Perikanan Budidaya, Tb Haeru Rahayu.</p>"
    },
    {
      id: 6,
      title: "Menteri Trenggono Jaga Produk Perikanan dari Pencemaran Mikroplastik",
      scope: [
        {
          title: "KEMENTERIAN KELAUTAN DAN PERIKANAN",
          code: "MENTERI"
        }
      ],
      created: "19 Maret 2023",
      image: "https: //portalkkp.coofis.com/media/news_kkp/news6.jpeg",
      by: "DIREKTORAT JENDERAL PERIKANAN TANGKAP",
      subtitle: "<p>SEMARANG (19/03) - Menteri Kelautan dan Perikanan Sakti Wahyu Trenggono menegaskan komitmen KKP menjaga mutu produk perikanan, termasuk dari kontaminasi mikroplastik. Upaya yang dilakukan pun harus dari hulu ke hilir.</p>",
      description: "<p>'Kualitas atau penjaminan mutu produk perikanan harus dilakukan dari hulu ke hilir. Dimulai dari produksi hingga sampai ke tangan konsumen, ini menjadi penting, khususnya melindungi sumber daya hayati ikan kita agar tetap sehat, bermutu dan bebas mikroplastik,' tegas Menteri Trenggono dalam acara Pencangan Bulan Mutu Karaninta (BMK) 2023 di Semerang, Jawa Tengah, Minggu (19/3).</p>"
    }
];

export default newsData;